// import angular from 'angular';

/* eslint-disable */
export default function PandemicPlanProcedureController(
  $sce,
) {
  const vm = this;
  vm.htmlProc = vm.procedure.pandemicInformation ? $sce.trustAsHtml(vm.procedure.pandemicInformation) : '';
}

PandemicPlanProcedureController.$inject = [
  '$sce',
];
